import React from 'react'
import DateHelper from '../../../../_plugins/lib/dateHelper.js'
import { string } from 'prop-types'

class DiscountTime extends React.Component {
  getFirstDayOfCurrentMonth (date, type) {
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    if (type === 'full') return firstDay.getDate() + DateHelper.getOrdinal(firstDay.getDate())
    if (type === 'iso') return this.getISO8601DateString(firstDay)
  }

  getLastDayOfCurrentMonth (date, type) {
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    if (type === 'full') return lastDay.getDate() + DateHelper.getOrdinal(lastDay.getDate())
    if (type === 'iso') return this.getISO8601DateString(lastDay)
  }

  getISO8601DateString (date) {
    const month = (date.getMonth() + 1).toString()
    const paddedMonth = ('00' + month).substring(month.length)
    const day = (date.getDate()).toString()
    const paddedDay = ('00' + day).substring(day.length)
    return date.getFullYear() + '-' + paddedMonth + '-' + paddedDay
  }

  render () {
    const todaysDate = new Date()
    const firstDayOfMonth = this.getFirstDayOfCurrentMonth(todaysDate, 'full')
    const lastDayOfMonth = this.getLastDayOfCurrentMonth(todaysDate, 'full')
    const monthAndYearName = DateHelper.getMonthName(todaysDate.getMonth()) + ' ' + todaysDate.getFullYear()
    const startIso = this.getFirstDayOfCurrentMonth(todaysDate, 'iso')
    const endIso = this.getLastDayOfCurrentMonth(todaysDate, 'iso')
    const { id } = this.props
    return (
      <div className='discount-date' id={id}>
        <time itemProp='startDate' dateTime={startIso}>Added {firstDayOfMonth} {monthAndYearName}</time>
        <time itemProp='endDate' dateTime={endIso}>- Expires {lastDayOfMonth} {monthAndYearName}</time>
      </div>
    )
  }
}

DiscountTime.propTypes = {
  id: string.isRequired
}

export default DiscountTime



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/discountTime.jsx